import { normalizeLocale, type SupportedLocale } from '@/i18n/config';

type RealtimeVoiceInstructionCopy = {
  questionnairePivotClarification: string;
};

const COPY_BY_LOCALE: Record<SupportedLocale, RealtimeVoiceInstructionCopy> = {
  en: {
    questionnairePivotClarification:
      'Do you want me to use that as the answer to this question, or start a new request?',
  },
  'pt-BR': {
    questionnairePivotClarification:
      'Quer que eu use isso como resposta para esta pergunta, ou come\u00E7ar um novo pedido?',
  },
  ar: {
    questionnairePivotClarification:
      'هل أستخدم ذلك إجابةً عن هذا السؤال، أم أبدأ طلبًا جديدًا؟',
  },
  es: {
    questionnairePivotClarification:
      '¿Quieres que use eso como respuesta a esta pregunta o que empiece una solicitud nueva?',
  },
  fr: {
    questionnairePivotClarification:
      'Voulez-vous que j’utilise cela comme réponse à cette question ou que je commence une nouvelle demande ?',
  },
  it: {
    questionnairePivotClarification:
      'Vuoi che usi questa come risposta alla domanda o che inizi una nuova richiesta?',
  },
  ko: {
    questionnairePivotClarification:
      '이 내용을 이 질문의 답변으로 사용할까요, 아니면 새 요청을 시작할까요?',
  },
  de: {
    questionnairePivotClarification:
      'Soll ich das als Antwort auf diese Frage verwenden oder eine neue Anfrage beginnen?',
  },
  ja: {
    questionnairePivotClarification:
      'これをこの質問の回答として使いますか、それとも新しい依頼を始めますか？',
  },
  hi: {
    questionnairePivotClarification:
      'क्या मैं इसे इस सवाल का जवाब मानूँ, या नया अनुरोध शुरू करूँ?',
  },
  ru: {
    questionnairePivotClarification:
      'Использовать это как ответ на текущий вопрос или начать новый запрос?',
  },
  zh: {
    questionnairePivotClarification:
      '你希望我把这作为当前问题的答案，还是开始一个新请求？',
  },
  'zh-TW': {
    questionnairePivotClarification:
      '你希望我把這當作目前問題的答案，還是開始新的請求？',
  },
  vi: {
    questionnairePivotClarification:
      'Bạn muốn tôi dùng nội dung đó làm câu trả lời cho câu hỏi này hay bắt đầu một yêu cầu mới?',
  },
  id: {
    questionnairePivotClarification:
      'Apakah Anda ingin saya menggunakan itu sebagai jawaban untuk pertanyaan ini atau memulai permintaan baru?',
  },
};

export function getRealtimeVoiceInstructionCopy(
  locale: string | null | undefined
): RealtimeVoiceInstructionCopy {
  return COPY_BY_LOCALE[normalizeLocale(locale)];
}
